<template>
    <div class="hero__content">
        <div class="container">
            <img v-if="logo" 
                class="hero__logo pb-1"
                :src="$helpers.image(logo, '600x0_ratio')"
                :alt="logo.localized.description">

            <h1 v-if="title" class="hero__title">{{ title }}</h1>
            <h2 v-if="subtitle" class="hero__subtitle">{{ subtitle }}</h2>
            <div v-if="content || $slots.default" class="row justify-content-center">
                <div class="hero__text col-md-8">
                    <div v-if="content" v-parse-content v-html="content"></div>
                    <slot></slot>
                </div>
            </div>

            <transition name="slide">
                <div v-if="playbutton" class="hero__playBtn">
                    <div class="play" @click="$emit('clickPlayButton', $event)">
                        <div class="play__btn"></div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'subtitle', 'content', 'logo', 'playbutton']
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/HeroElements/Content.vue